export function isBrowser() {
  return typeof window !== 'undefined';
}
const wholeName = /[a-zA-Z.'-]{2,}(?: [a-zA-Z.'-]{2,})+$/;
const singularName = /([a-zA-Z.'-]{2,})+$/;
const lower = /[a-z]/;
const upper = /[A-Z]/;
const number = /[0-9]/;
const symbol = /[-!@$%^&*()_+|~=#`{}[\]:";'<>?,./]/;
const noSpace = /^\S*$/;
const validEmail = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/;

export const errorMessages = {
  name: 'Improperly formatted name',
  email: 'Enter a valid email (john@example.com)',
  password: 'Password does not meet the character requirement',
  confirmPassword: 'Passwords do not match',
  checkbox: 'You must be over 18 to sign up.',
};

export function getHasValidFullName({ fullName }) {
  return wholeName.test(fullName);
}

export function getHasValidName({ name }) {
  return singularName.test(name);
}

export function getHasLowercase({ password }) {
  return lower.test(password);
}

export function getHasUppercase({ password }) {
  return upper.test(password);
}

export function getHasNumber({ password }) {
  return number.test(password);
}

export function getHasSymbol({ password }) {
  return symbol.test(password);
}

export function getHasNoSpaces({ password }) {
  return password.length === 0 ? false : noSpace.test(password);
}

export function getHasLength({ password = '', length }) {
  return password.length >= length;
}

export function getIsPasswordValid({ password }) {
  return (
    getHasLength({ password, length: 8 }) &&
    getHasLowercase({ password }) &&
    getHasUppercase({ password }) &&
    getHasNumber({ password }) &&
    getHasSymbol({ password }) &&
    getHasNoSpaces({ password })
  );
}

export function getHasValidEmail({ email }) {
  return validEmail.test(email);
}